const QuickActions = ({ actions, title, subtitle }) => {
  return (
    <div className="chart-container h-100">
      <h3 className="chart-title">{title}</h3>
      <h6 className="chart-subtitle">{subtitle}</h6>
      <div className="quick-actions-grid">
        {actions.map((action, index) => (
          <div
            key={index}
            className="quick-action-card"
            onClick={action.onClick}
          >
            <div className="quick-action-icon">{action.icon}</div>
            <div className="quick-action-label">{action.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
